/**
 * The edge `matches` picks, in `locale` if there is one, else in English.
 * The locale queries return every language of each item, so each lookup
 * chooses one.
 */
export function pickLocalized<E extends { node: { locale: string } }>(
  edges: E[],
  matches: (edge: E) => boolean,
  locale: string,
): E | undefined {
  return (
    edges.find((e) => matches(e) && e.node.locale === locale) ??
    edges.find((e) => matches(e) && e.node.locale === 'en')
  );
}
